async function waitForCmp() {
    let cmpIsDefined = false;
    while(!cmpIsDefined) {
        if(typeof __cmp === "function") {
            cmpIsDefined = true;
            return true;
        } else {
            await sleepHelper(300);
        }
    }
}

function sleepHelper(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function updateShopifyConsentBasedOnCmp() {
    var result = __cmp('getCMPData');
    if(!result || !result.purposeConsents || Object.keys(result.purposeConsents).length == 0) {
        return;
    }

    const marketingConsent = result.purposeConsents.c52 || false;
    const preferencesConsent = result.purposeConsents.c53 || false;
    const measurementConsent = result.purposeConsents.c54 || false;

    const shopifyPrivacySettings = {
        "analytics": measurementConsent,
        "marketing": marketingConsent,
        "preferences": preferencesConsent,
        "sale_of_data": marketingConsent
    }

    const compareCurrentConsent = () => {
        const currentShopifyConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
        let consentMatches = true;
        Object.keys(currentShopifyConsent).forEach(marketingCategory => {
            if(marketingCategory in shopifyPrivacySettings) {
                const currentShopifyConsentValue = currentShopifyConsent[marketingCategory] === "yes" ? true : false;
                const shopifyPrivacySettingsValue = shopifyPrivacySettings[marketingCategory];
                if(currentShopifyConsentValue != shopifyPrivacySettingsValue) {
                    consentMatches = false;
                }
            }
        });

        return consentMatches;

    }

    const passTrackingConsent = () => {
        let setConsentCount = 0;
        const intervalId = setInterval(() => {
            const currentStoredTracking = window.Shopify.customerPrivacy.currentVisitorConsent();
            if(compareCurrentConsent()) {
                clearInterval(intervalId);
                console.log("Successfully passed tracking consent to shopify");
                // Event for enhanced-datalayer.js
                window.customCmpConsentLoaded = true;
                window.dispatchEvent(new CustomEvent("customCmpConsentLoaded"));
                return;
            }

            if(setConsentCount > 5) {
                clearInterval(intervalId);
                console.log("Was not able to pass tracking consent to shopify");
                return;
            }

            window.Shopify.customerPrivacy.setTrackingConsent(
                shopifyPrivacySettings,
                (setError) => {
                    if(setError) {
                        console.error(setError);
                        clearInterval(intervalId);
                        return;
                    }
                    console.log("Passing tracking consent to shopify", shopifyPrivacySettings)
                }
            );
            setConsentCount = setConsentCount + 1;
        }, 500);
    }

    window.Shopify.loadFeatures(
        [
            {
            name: 'consent-tracking-api',
            version: '0.1',
            },
        ],
        error => {
            if (error) {
                console.error(error);
                return;
            }
            // Timeout ensures that tracking api is fully loaded
            
            passTrackingConsent();
            
        },
    );
}

waitForCmp().then(() => {
    updateShopifyConsentBasedOnCmp();
    __cmp("addEventListener",["consent",updateShopifyConsentBasedOnCmp,false],null);
})

function acceptShopifyConsent() {
    const consentData = {
        "analytics": true,
        "marketing": true,
        "preferences": true,
        "sale_of_data": false
    }
    window.Shopify.customerPrivacy.setTrackingConsent(
        consentData,
        (setError) => {
            if(setError) {
                console.error(setError);
            } else {
                console.log("Consent captured", consentData)
            }
        }
    );
}

function getCurrentShopifyConsentData() {
    window.Shopify.loadFeatures(
        [
            {
            name: 'consent-tracking-api',
            version: '0.1',
            }
        ],
        error => {
            if (error) {
                console.error(error);
                return;
            }
            console.log(window.Shopify.customerPrivacy.currentVisitorConsent());
        },
    );
}

